import { render, staticRenderFns } from "./ColorFamilyDialog.vue?vue&type=template&id=3b52378f"
import script from "./ColorFamilyDialog.vue?vue&type=script&lang=js"
export * from "./ColorFamilyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports